import { ISelect } from "../model/iSelect";
import { IProvince } from "../model/province.model";

export const provinceOptionsByCountry = (
  provinces: IProvince[] | any,
  countryId: number,
): Array<IProvince> => {
  const options: Array<IProvince> = provinces
    ? provinces.filter((prov: IProvince) => prov?.country?.id === countryId)
    : [];
  return options;
};

export const provincesOptions = (provinces: IProvince[] | any): [] => {
  const options: [] = provinces
    ? provinces.map((p: IProvince) => ({
        value: p.id,
        label: p.name,
      }))
    : null;

  return options;
};

export const provinceById = (
  provinces: readonly IProvince[] | any,
  ids: number[],
): Array<ISelect> => {
  const provincesToSelect: ISelect[] = [];
  provinces.forEach((element: IProvince) => {
    if (ids.indexOf(element.id!) >= 0) {
      provincesToSelect.push({ value: element.id, label: element.name });
    }
  });
  return provincesToSelect;
};
